import React from 'react';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledIcon = styled(IconMaterial, {
  verticalAlign: 'middle',
  display: 'inline-flex !important',
});

const StyledDiv = styled('div', {
  display: 'inline-block',
  height: '100%',
  marginLeft: 5,
});

export const DefaultDivider = () => {
  return (
    <StyledDiv>
      <StyledIcon icon='arrow_right' color='$black' />
    </StyledDiv>
  );
};
